<div class="bus-loader__container">
  <ng-lottie 
    class="bus-loader__animation"
    [options]="options"
  />
  
  @if (title()) {
    <p class="bus-loader__text ci-paragraph-p1-regular">
      {{ title()}}
    </p>
  }
    
  @if (subtitle()) {
    <p class="bus-loader__text bus-loader__text--subtitle ci-paragraph-p1-regular">
      {{ subtitle() }}
    </p>
  }
</div>

